


























import { Component, Prop, Vue } from "vue-property-decorator";
import DashCard from "@/components/app/shared/cards/dash-card.vue";
import { ITelemetryTemperature } from "@/@types/servers/telemetry";

@Component({
  components: { DashCard },
})
export default class TemperatureCard extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  readonly temperature!: ITelemetryTemperature;

  get validSensors(): { [key: string]: { temperature: number } } {
    const result: { [key: string]: { temperature: number } } = {};
    for (const [key, val] of Object.entries(this.temperature)) {
      if (val && typeof val.temperature === "number" && val.temperature > 0) {
        result[key] = val as { temperature: number };
      }
    }
    return result;
  }

  sensorLabel(key: string): string {
    const translation = this.$t(`temp.${key}`);
    if (translation !== `temp.${key}`) return String(translation);
    return key;
  }

  tempPercent(temp: number): number {
    return Math.min((temp / 100) * 100, 100);
  }

  tempClass(temp: number): string {
    if (temp > 80) return "temp-critical";
    if (temp > 60) return "temp-warm";
    if (temp > 40) return "temp-normal";
    return "temp-cool";
  }
}
